import { Vue } from 'ui.vue';

Vue.component('bx-table-head', {
	props: {
		head: {
			type: String,
			required: true,
		},
	},
	template: `
	  	<div>
	  		<slot name="title">
					
				</slot>
			  <slot name="sorter"></slot>
			  
			
	  		<slot name="filter"></slot>
		</div> 
	  `
})